import MENTEE_STATUS, { MenteeStatusValues } from 'enums/MenteeStatus';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC } from 'react';
import Chip from '../Chip';
import MentorshipStatusChip from './MentorshipStatusChip';

type Props = {
  status: MenteeStatusValues;
  mentorshipStatus: MentorshipStatusValues;
};
const MenteeStatusChip: FC<Props> = ({ status, mentorshipStatus }) => {
  switch (status) {
    case 'REFUSED':
    case 'REFUSED_MENTORSHIP':
    case 'FILLING_FORM':
      return (
        <Chip bgColor="#F2F4F7" color="#344054">
          {MENTEE_STATUS[status]}
        </Chip>
      );
    case 'SIGNING_CHART':
      return (
        <Chip bgColor="#FFF6ED" color="#C4320A">
          {MENTEE_STATUS[status]}
        </Chip>
      );
    case 'ELIGIBLE':
      return (
        <Chip bgColor="#FEF3F2" color="#B42318">
          {MENTEE_STATUS[status]}
        </Chip>
      );
    case 'MENTORSHIP_ACTIVE':
      return <MentorshipStatusChip status={mentorshipStatus} />;
    default:
      return null;
  }
};

export default MenteeStatusChip;
